export enum NotificationActions {
  ADD = 'add_notification',
  MAKE_REED = 'make_reed',
}